// extracted by mini-css-extract-plugin
export var clauseRow = "_47-6";
export var emptyState = "_47-b";
export var filterContent = "_47-a";
export var filterGroup = "_47-1";
export var filterGroupContainer = "_47-0";
export var nestedGroup = "_47-2";
export var nestedGroupDepth1 = "_47-3";
export var nestedGroupDepth2 = "_47-4";
export var nestedGroupDepth3 = "_47-5";
export var operatorAnd = "_47-8";
export var operatorOr = "_47-9";
export var operatorToggle = "_47-7";
export var removeGroupButton = "_47-c";